<template>
  <div>
    <section role="modal">
      <div
        class="modal fade"
        id="explicacaoModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="explicacaoModalLabel"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 class="modal-title" id="explicacaoModalLabel">
                Entenda o Paraceiro Econômico
              </h4>
            </div>
            <div class="modal-body">
              <div class="row row-field" style="padding-bottom: 15px">
                <div class="col-md-12 col-sm-12">
                  <p style="text-align: justify">
                    <strong>Parceiro econômico</strong> é aquele que participa
                    economicamente dos bens declarados.
                  </p>
                  <p>
                    <strong>Importante:</strong> não se faz necessário cadastrar
                    parceiros
                    <strong>sem CPF.</strong>
                  </p>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <botao
                estilo="cheio-verde"
                rotulo="Entendi"
                icone="ok-modal"
                dismiss="modal"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
    <section role="side-modal">
      <side-modal :sides="navs" @cancela="cancela()">
        <template :slot="navs[0].identidade">
          <div class="side-body">
            <div class="row">
              <form>
                <div class="row row-field">
                  <field-validation
                    css-class="col-md-6 col-sm-6"
                    label="CPF"
                    field="cpf"
                    :status="errors"
                    :custom-errors="apiErrors"
                    :show-icon="false"
                  >
                    <input
                      type="text"
                      name="cpf"
                      id="cpf"
                      class="form-control"
                      v-validate="'required|min:14'"
                      data-vv-as="CPF"
                      @change="verificaCpf($event.target.value)"
                      v-model="dependenciaModal.dependente.cpf"
                      v-mask="'###.###.###-##'"
                    />
                  </field-validation>
                  <field-validation
                    css-class="col-md-6 col-sm-6"
                    label="Data de Nascimento"
                    field="dataNascimento"
                    :status="errors"
                    :custom-errors="apiErrors"
                    :show-icon="false"
                    v-if="telaEhMobile"
                  >
                    <input
                      type="date"
                      name="dataNascimento"
                      id="dataNascimento"
                      class="form-control"
                      v-model="dependenciaModal.dependente.dataNascimento"
                      v-validate="'required'"
                      data-vv-as="Data de Nascimento"
                    />
                  </field-validation>
                  <field-validation
                    css-class="col-md-6 col-sm-6"
                    label="Data de Nascimento"
                    field="dataNascimento"
                    :status="errors"
                    :custom-errors="apiErrors"
                    :show-icon="false"
                    v-else
                  >
                    <date-picker
                      name="dataNascimento"
                      id="dataNascimento"
                      :config="config"
                      v-model="dependenciaModal.dependente.dataNascimento"
                      v-validate="'required'"
                      data-vv-as="Data de Nascimento"
                    />
                  </field-validation>
                </div>
                <div class="row row-field">
                  <field-validation
                    css-class="col-md-12 col-sm-12"
                    label="Nome"
                    field="nome"
                    :status="errors"
                    :custom-errors="apiErrors"
                    :show-icon="false"
                  >
                    <input
                      type="text"
                      name="nome"
                      id="nome"
                      class="form-control"
                      autofocus="autofocus"
                      v-model="dependenciaModal.dependente.nome"
                      v-validate="'required|max:50'"
                      data-vv-as="Nome"
                    />
                  </field-validation>
                </div>
                <div class="row row-field">
                  <field-validation
                    css-class="col-md-6 col-sm-6"
                    label="Parentesco"
                    field="parentesco"
                    :status="errors"
                    :custom-errors="apiErrors"
                    :show-icon="false"
                  >
                    <select
                      class="form-control"
                      name="parentesco"
                      v-model="dependenciaModal.grau"
                      v-validate="'required'"
                      data-vv-as="Parentesco"
                    >
                      <option value :selected="true">Escolha</option>
                      <option
                        v-for="grau in graus"
                        :value="grau.name"
                        :key="graus.indexOf(grau)"
                      >
                        {{ grau.displayName | tudoMaiusculo }}
                      </option>
                    </select>
                  </field-validation>
                  <field-validation
                    css-class="col-md-6 col-sm-6"
                    label="Sexo"
                    field="sexo"
                    :status="errors"
                    :custom-errors="apiErrors"
                    :show-icon="false"
                  >
                    <select
                      class="form-control"
                      name="sexo"
                      id="sexo"
                      v-model="dependenciaModal.dependente.sexo"
                      v-validate="'required'"
                      data-vv-as="Sexo"
                    >
                      <option value :selected="true">Escolha</option>
                      <option
                        v-for="sexo in sexos"
                        :value="sexo.name"
                        :key="sexos.indexOf(sexo)"
                      >
                        {{ sexo.displayName | tudoMaiusculo }}
                      </option>
                    </select>
                  </field-validation>
                </div>
                <div class="row row-field">
                  <div v-if="rendasOrdenadas.length === 0">
                    <div
                      class="col-xs-12 form-group"
                      style="margin-bottom: 2px"
                    >
                      <label>Renda Anual</label>
                    </div>
                  </div>
                  <div v-else>
                    <div class="form-group col-lg-6 col-md-6 col-sm-6 col-xs-4">
                      <label>Ano Referência</label>
                      <p>{{ rendasOrdenadas[0].anoReferencia }}</p>
                    </div>
                    <div class="form-group col-lg-4 col-md-4 col-sm-4 col-xs-4">
                      <label>Renda Anual</label>
                      <p>{{ rendasOrdenadas[0].valor | monetarioMask }}</p>
                    </div>
                    <div
                      class="col-lg-2 col-md-2 col-sm-2 col-xs-4"
                      style="text-align: right; padding-top: 15px"
                    >
                      <botao
                        tipo="button"
                        estilo="vazado-cinza-sm"
                        icone="editar-tabela"
                        @clicado="editaRenda(dependenciaModal)"
                      />
                    </div>
                  </div>
                  <div v-show="!rendaEhAnoAtual" class="col-xs-12">
                    <p class="alert alert-warning" style="text-align: center">
                      <i class="fa fa-flag-o fa-lg"></i>
                      &nbsp; Se houver, cadastre a renda de
                      {{ anoReferenciaAtual }}.
                    </p>
                  </div>
                  <div class="row-field visible-xs">
                    <div
                      class="col-xs-12 footer-controller-inner-modal"
                      style="margin-top: -7px"
                    >
                      <botao
                        tipo="button"
                        estilo="vazado-verde-dir"
                        rotulo="Renda"
                        icone="mais"
                        @clicado="novaRenda()"
                      />
                    </div>
                  </div>
                  <div
                    class="col-xs-12 footer-controller-inner-modal hidden-xs"
                    style="margin-top: -7px"
                  >
                    <botao
                      tipo="button"
                      estilo="vazado-verde-dir"
                      rotulo="Renda"
                      icone="mais"
                      @clicado="novaRenda()"
                    />
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div class="side-footer">
            <botao
              tipo="button"
              estilo="cheio-cinza"
              rotulo="Cancelar"
              icone="cancela-modal"
              @clicado="cancela()"
            />
            <botao
              tipo="button"
              estilo="cheio-verde"
              rotulo="Salvar"
              icone="ok-modal"
              @clicado="valida()"
            />
          </div>
        </template>
        <template :slot="navs[1].identidade">
          <div class="side-body">
            <div class="row">
              <div class="row row-field">
                <field-validation
                  css-class="col-xs-7 col-sm-4"
                  label="Ano Ref."
                  field="ano-referencia"
                  :status="errors"
                  :custom-errors="apiErrors"
                  :show-icon="false"
                  v-if="anoEditavel"
                >
                  <input
                    style="max-width: 203px"
                    type="text"
                    name="ano-referencia"
                    id="ano-referencia"
                    class="form-control"
                    v-model="rendaModal.anoReferencia"
                    v-validate="
                      `required|numeric|max_value:${anoReferenciaAtual}`
                    "
                    data-vv-as="Ano Ref."
                  />
                </field-validation>
                <div class="form-group col-xs-7 col-sm-4" v-else>
                  <label>Ano Ref.</label>
                  <p>{{ rendaModal.anoReferencia }}</p>
                </div>
                <div class="col-xs-12 col-sm-8" style="display: flex">
                  <div class="form-group">
                    <label>Renda Anual</label>
                    <money
                      type="text"
                      name="rendaModal"
                      id="rendaModal"
                      class="form-control"
                      v-model="rendaModal.valor"
                    />
                  </div>
                  <div style="margin-left: 30px">
                    <botao
                      tipo="button"
                      estilo="vazado-verde-inline"
                      icone="fa-plus fa-lg"
                      @clicado="incluiRenda()"
                    />
                  </div>
                </div>
              </div>
              <section role="table">
                <div class="table-responsive" style="padding: 0 15px">
                  <div
                    class="alert alert-warning"
                    role="alert"
                    style="text-align: center"
                    v-if="listaDeRendasModal.length === 0"
                  >
                    <i class="fa fa-flag-o fa-lg"></i>&nbsp; Não existe renda
                    cadastrada.
                  </div>
                  <table class="table table-striped table-hover" v-else>
                    <thead>
                      <tr>
                        <th>Ano</th>
                        <th>Valor</th>
                        <th>&nbsp;</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="cadaRenda in rendasOrdenadasModal"
                        :key="cadaRenda.anoReferencia"
                      >
                        <td>{{ cadaRenda.anoReferencia }}</td>
                        <td>{{ cadaRenda.valor | monetarioMask }}</td>
                        <td class="td-btns td-btns-alone">
                          <botao
                            tipo="button"
                            estilo="vazado-cinza-sm"
                            icone="editar-tabela"
                            @clicado="editaRendaModal(cadaRenda)"
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </section>
            </div>
          </div>
          <div class="side-footer">
            <botao
              tipo="button"
              estilo="cheio-cinza"
              rotulo="Cancelar"
              icone="cancela-modal"
              @clicado="cancelaRenda()"
            />
            <botao
              tipo="button"
              estilo="cheio-verde"
              rotulo="Salvar Rendas"
              icone="ok-modal"
              @clicado="salvaRenda()"
            />
          </div>
        </template>
      </side-modal>
    </section>
    <section role="table">
      <div class="main-container container container-top">
        <div class="row">
          <div class="col-md-12">
            <div class="card card-default">
              <div class="card-content">
                <h4>
                  Parceiros Econômicos&nbsp;
                  <small>
                    <a @click="abreExplicacaoModal()" style="cursor: pointer"
                      >(Quem é considerado parceiro econômico?)</a
                    >
                  </small>
                </h4>
                <div>
                  <table-loader :carregando="carregando">
                    <div
                      class="alert alert-warning"
                      role="alert"
                      style="text-align: center"
                      v-if="dependencias.length == 0"
                    >
                      <i class="fa fa-flag-o fa-lg"></i>&nbsp; Não existem
                      parceiros cadastrados.
                    </div>
                    <table class="table table-striped table-hover" v-else>
                      <thead>
                        <tr>
                          <th>Nome</th>
                          <th class="hidden-xs">CPF</th>
                          <th class="hidden-xs hidden-sm">
                            Grau de Parentesco
                          </th>
                          <th>&nbsp;</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="dependencia in dependenciasOrdenadas"
                          :key="dependencias.indexOf(dependencia)"
                        >
                          <td>{{ dependencia.dependente.nome }}</td>
                          <td class="hidden-xs">
                            {{ dependencia.dependente.cpf | cpfMask }}
                          </td>
                          <td class="hidden-xs hidden-sm">
                            {{ dependencia.grau | grauParentescoFilter }}
                          </td>
                          <td class="td-btns">
                            <botao
                              tipo="button"
                              estilo="vazado-vermelho-sm"
                              icone="exclui-tabela"
                              v-tooltip.left="'Apagar'"
                              @clicado="exclui(dependencia)"
                            />
                            <botao
                              tipo="button"
                              estilo="vazado-cinza-sm"
                              icone="editar-tabela"
                              v-tooltip.right="'Editar'"
                              @clicado="edita(dependencia)"
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div class="col-xs-12 footer-controller-inner">
                      <botao
                        tipo="button"
                        estilo="cheio-verde-dir"
                        rotulo="Novo"
                        icone="novo-modal"
                        toggle
                        target
                        @clicado="novo()"
                      />
                    </div>
                  </table-loader>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Botao from '@/components/botao';
import SideModal from '@/components/side-modal';
import TableLoader from '@/components/table-loader';
import moment from 'moment';
import DependenciasService from '@/services/dependenciasService';
import Dependencia from '@/domain/dependencia';
import Dependente from '@/domain/dependencia/dependente';
import Renda from '@/domain/dependencia/renda';
import DateHelper from '@/helpers/DateHelper';
import StringHelper from '@/helpers/StringHelper';
import CpfHelper from '@/helpers/CpfHelper';
import ArrayHelper from '@/helpers/ArrayHelper';
import ErrorHelper from '@/helpers/ErrorHelper';
import '@/filters/filters';

export default {
  name: 'Dependente',

  data() {
    return {
      apiErrors: null,
      carregando: false,
      dependencias: [],
      autenticado: {},
      declarante: { id: null },
      dependente: {},
      dependencia: {},
      dependenciaModal: {},
      graus: this.$store.state.graus,
      sexos: [
        {
          displayName: 'Masculino',
          name: 'M',
        },
        {
          displayName: 'Feminino',
          name: 'F',
        },
      ],
      rendaModal: {},
      listaDeRendasModal: [],
      anoEditavel: false,
      anoReferenciaAtual: 0,
      navs: [
        {
          titulo: 'Parceiro',
          subtitulo: 'Dados Pessoais',
          subtDetalhe: 'Novo Parceiro',
          largura: 600,
          identidade: 'dependente',
          abreProximo: false,
          aberto: false,
        },
        {
          titulo: 'Parceiro',
          subtitulo: 'Rendas Anuais',
          subtDetalhe: 'Novo Parceiro',
          largura: 600,
          identidade: 'rendas',
          abreProximo: false,
          aberto: false,
        },
      ],
      config: {
        format: 'L',
        useCurrent: false,
        locale: 'pt-br',
        maxDate: moment(new Date()),
        minDate: moment(new Date()).add(-100, 'years'),
      },
    };
  },

  computed: {
    dependenciasOrdenadas() {
      this.dependencias.forEach(
        dependencia =>
          (dependencia.nomeDependente = dependencia.dependente.nome),
      );

      return this.dependencias.sort(
        ArrayHelper.compareValues('nomeDependente'),
      );
    },
    rendasOrdenadas() {
      return this.dependenciaModal.rendas.sort(
        (a, b) => b.anoReferencia - a.anoReferencia,
      );
    },
    rendasOrdenadasModal() {
      return this.listaDeRendasModal.sort(
        (a, b) => b.anoReferencia - a.anoReferencia,
      );
    },
    rendaEhAnoAtual() {
      return this.rendasOrdenadas.length
        ? this.rendasOrdenadas[0].anoReferencia == this.anoReferenciaAtual
        : false;
    },
    telaEhMobile() {
      return window.innerWidth <= 768;
    },
  },

  methods: {
    abreModal(identidade) {
      this.$emit('abreModal', identidade);
    },
    fechaModal(identidade) {
      this.$emit('fechaModal', identidade);
    },
    abreExplicacaoModal() {
      jQuery('#explicacaoModal').modal('show');
    },
    novo() {
      this.navs[0].subtDetalhe = 'Novo Parceiro';
      this.desabilitaCampos(false, false, false, false);
      this.abreModal('dependente');
      this.errors.clear();
    },
    async verificaCpf(cpf) {
      let cpfLimpo = StringHelper.limpaFormato(cpf);
      try {
        // Verifica se o cpf é diferente do usuário logado (declarante)
        if (cpfLimpo === this.autenticado.cpf) {
          throw new Error(
            'O declarante não pode ser o parceiro. Verifique o CPF.',
          );
        }
        // Verifica se o cpf já existe na lista de dependentes
        if (
          this.dependencias.some(
            dependencia => dependencia.dependente.cpf === cpf,
          )
        ) {
          throw new Error('Parceiro já cadastrado');
        }
        // Verifica se o cpf é válido
        if (!CpfHelper.testaCpf(cpfLimpo)) {
          throw new Error('Número de CPF inválido');
        }
        // Verifica se o dependente já está na base de dados
        const dependente = await DependenciasService.obtemDependente(cpfLimpo);
        this.dependente = dependente;
        this.dependente.cpf = CpfHelper.cpfFormatado(dependente.cpf);

        if (!this.telaEhMobile) {
          this.dependente.dataNascimento = DateHelper.convertDateToPtbr(
            dependente.dataNascimento,
          );
        }

        this.dependenciaModal.dependente = this.dependente;
        this.desabilitaCampos(false, true, true, true);
      } catch (error) {
        this.limpaCpfAnterior();
        this.dependente.cpf = cpf;
        const mensagem = ErrorHelper.trataMensagem(error);
        if (mensagem === 'Recurso não encontrado') return;
        this.$root.$refs.toastr.e(mensagem, 'Atenção');
      }
    },
    limpaCpfAnterior() {
      this.dependente = new Dependente();
      this.dependenciaModal = new Dependencia(this.declarante, this.dependente);
      this.desabilitaCampos(false, false, false, false);
    },
    valida() {
      this.$validator.validateAll().then(success => {
        if (success) {
          this.salva();
          return;
        }
        this.$root.$refs.toastr.e(
          'Preencha ou corrija os campos em vermelho',
          'Atenção',
        );
      });
    },
    edita(dependencia) {
      this.navs[0].subtDetalhe = dependencia.dependente.nome;

      if (!this.telaEhMobile) {
        dependencia.dependente.dataNascimento = DateHelper.convertDateToPtbr(
          dependencia.dependente.dataNascimento,
        );
      }
      this.dependenciaModal = JSON.parse(JSON.stringify(dependencia));
      this.desabilitaCampos(true, false, false, false);
      this.abreModal('dependente');
    },
    exclui(dependencia) {
      const sentences = [
        {
          id: 1,
          message: 'Deseja excluir esse dependente da sua lista?',
          bold: false,
        },
      ];

      this.$root.$refs.modal.confirm(sentences, {
        yes: async () => {
          try {
            await DependenciasService.apaga(dependencia.id);
            this.dependencias.splice(this.dependencias.indexOf(dependencia), 1);
            this.$root.$refs.toastr.s('Dependente excluído', 'Sucesso');
          } catch (error) {
            const mensagem = ErrorHelper.trataMensagem(error);
            this.$root.$refs.toastr.e(mensagem, 'Atenção');
          }
        },
        title: 'Deletando Dependente',
      });
    },
    async salva() {
      this.dependencia = JSON.parse(JSON.stringify(this.dependenciaModal));
      this.dependencia.dependente.cpf = StringHelper.limpaFormato(
        this.dependencia.dependente.cpf,
      );
      this.dependencia.dependente = StringHelper.toUpperCaseInJson(
        this.dependencia.dependente,
      );
      if (!this.telaEhMobile) {
        this.dependencia.dependente.dataNascimento = DateHelper.convertPtbrToApiDate(
          this.dependencia.dependente.dataNascimento,
        );
      }
      if (this.dependencia.rendas.length === 0) delete this.dependencia.rendas;

      try {
        if (this.dependencia.id) {
          await DependenciasService.atualiza(
            this.dependencia.id,
            this.dependencia,
          );
          await this.listaDependentes();
          this.fechaModal('dependente');
          this.limpaModal();
          this.$root.$refs.toastr.s('Dependente atualizado', 'Sucesso');
        } else {
          const response = await DependenciasService.grava(this.dependencia);
          this.dependencias.push(response);
          this.fechaModal('dependente');
          this.limpaModal();
          this.$root.$refs.toastr.s('Informação salva', 'Sucesso');
        }
      } catch (error) {
        const mensagem = ErrorHelper.trataMensagem(error);
        this.$root.$refs.toastr.e(mensagem, 'Atenção');
      }
    },
    cancela() {
      this.limpaModal();
      this.fechaModal('dependente');
    },
    desabilitaCampos(cpfBoolean, dataBoolean, nomeBoolean, sexoBoolean) {
      document.querySelector('#cpf').disabled = cpfBoolean;
      document.querySelector('#dataNascimento').disabled = dataBoolean;
      document.querySelector('#nome').disabled = nomeBoolean;
      document.querySelector('#sexo').disabled = sexoBoolean;
    },
    limpaModal() {
      setTimeout(() => {
        this.dependente = new Dependente();
        this.dependenciaModal = new Dependencia(
          this.declarante,
          this.dependente,
        );
      }, 600);
    },

    // Métodos do SidePanel
    novaRenda() {
      this.dependenciaModal.dependente.nome
        ? (this.navs[1].subtDetalhe = this.dependenciaModal.dependente.nome)
        : (this.navs[1].subtDetalhe = 'Novo Parceiro');
      this.listaDeRendasModal = JSON.parse(
        JSON.stringify(this.rendasOrdenadas),
      );
      this.anoEditavel = true;

      this.abreModal('rendas');
    },
    editaRenda(dependencia) {
      dependencia.dependente.nome
        ? (this.navs[1].subtDetalhe = dependencia.dependente.nome)
        : (this.navs[1].subtDetalhe = 'Novo Parceiro');
      this.listaDeRendasModal = JSON.parse(
        JSON.stringify(this.rendasOrdenadas),
      );
      this.rendaModal = JSON.parse(JSON.stringify(this.listaDeRendasModal[0]));

      this.abreModal('rendas');
    },
    incluiRenda() {
      if (this.rendaModal.valor) {
        this.rendaModal.valor = parseFloat(this.rendaModal.valor);
        let indexRenda = this.listaDeRendasModal.findIndex(renda => {
          return renda.anoReferencia == this.rendaModal.anoReferencia;
        });
        indexRenda >= 0
          ? this.listaDeRendasModal.splice(indexRenda, 1, this.rendaModal)
          : this.listaDeRendasModal.push(this.rendaModal);

        this.$root.$refs.toastr.s('Renda incluída', 'Sucesso');
        this.rendaModal = new Renda();
      } else {
        this.$root.$refs.toastr.e(
          'Preencha um valor a ser incluído',
          'Atenção',
        );
      }
    },
    editaRendaModal(renda) {
      this.rendaModal = JSON.parse(JSON.stringify(renda));
    },
    salvaRenda() {
      if (this.listaDeRendasModal.length && this.rendaModal.valor == 0) {
        this.dependenciaModal.rendas = JSON.parse(
          JSON.stringify(this.listaDeRendasModal),
        );
        this.$root.$refs.toastr.s('Renda salva na lista', 'Sucesso');
      } else {
        this.$root.$refs.toastr.e(
          `Você não incluiu um valor na lista.
                    Clique no botão "+" para alterar o valor ou clique em Cancelar`,
          'Atenção',
        );
        return;
      }
      this.fechaModal('rendas');
      this.limpaModalRenda();
    },
    cancelaRenda() {
      this.fechaModal('rendas');
      this.limpaModalRenda();
    },

    // Métodos auxiliares para SideModal Rendas
    desabilitaCamposRenda(cpfBoolean, dataBoolean, nomeBoolean, sexoBoolean) {
      document.querySelector('#cpf').disabled = cpfBoolean;
      document.querySelector('#dataNascimento').disabled = dataBoolean;
      document.querySelector('#nome').disabled = nomeBoolean;
      document.querySelector('#sexo').disabled = sexoBoolean;
    },
    limpaModalRenda() {
      setTimeout(() => {
        this.rendaModal = new Renda();
        this.listaDeRendasModal = [];
        this.anoEditavel = false;
      }, 600);
    },

    // Requisição
    async listaDependentes() {
      this.carregando = true;

      try {
        const dependencias = await DependenciasService.lista();
        this.dependencias = dependencias.content;
      } catch (error) {
        const mensagem = ErrorHelper.trataMensagem(error);
        this.$root.$refs.toastr.e(mensagem, 'Atenção');
      } finally {
        this.carregando = false;
      }
    },
  },

  created() {
    this.autenticado = this.$store.state.usuarioLogado;
    this.declarante.id = this.autenticado.idPessoa;
    this.anoReferenciaAtual = moment(new Date()).year() - 1;
    this.dependente = new Dependente();
    this.rendaModal = new Renda();
    this.dependenciaModal = new Dependencia(this.declarante, this.dependente);

    this.listaDependentes();
  },

  mounted() {
    window.scrollTo(0, 0);
  },

  components: {
    Botao,
    SideModal,
    TableLoader,
  },
};
</script>



// WEBPACK FOOTER //
// index.vue?8d2b7206